import { cn } from '@frontdoor/ui/lib/utils';

type PatientAvatarProps = {
  firstName: string;
  lastName: string;
  className?: string;
};

export function PatientAvatar({ firstName, lastName, className }: PatientAvatarProps) {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  return (
    <div
      className={cn(
        'flex size-10 items-center justify-center rounded-full border border-sand-100 bg-sand-50 text-sm font-medium text-charcoal-400',
        className
      )}
    >
      {initials}
    </div>
  );
}
